import { render, staticRenderFns } from "./inboundstatements.vue?vue&type=template&id=2bb08893&scoped=true"
import script from "./inboundstatements.vue?vue&type=script&lang=js"
export * from "./inboundstatements.vue?vue&type=script&lang=js"
import style0 from "./inboundstatements.vue?vue&type=style&index=0&id=2bb08893&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb08893",
  null
  
)

export default component.exports